import React, {memo} from 'react'

import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'
import SidebarSelect from '../../SidebarSelect/SidebarSelect'

import useJobParallelism from './JobParallelism.hooks'

function JobParallelism() {
  const {parallelismOptions, selectedOption, handlerParallelismSelect} = useJobParallelism()

  return (
    <SettingsBlock id={'parallelism'} title={'Parallelism'} collapsible>
      <SidebarSelect
        data={parallelismOptions}
        selected={selectedOption}
        onSelect={handlerParallelismSelect}
      />
    </SettingsBlock>
  )
}

export default memo(JobParallelism)
